import capitalizeFirst from '@zola-helpers/client/dist/es/transformers/capitalizeFirst';
import {
  SORT_DEFAULT,
  SORT_OPTIONS,
} from '~/cards/components/CardListing/CardListingRedesign/constants';
import {
  SearchFilters,
  FilterKey,
} from '~/cards/components/CardListing/CardListingRedesign/CardListingFilter/FilterTypes';

export const getSortLabel = (sorts?: string[]): string => {
  const sort = sorts?.[0] || SORT_DEFAULT;
  return SORT_OPTIONS.find((s) => s.value === sort)?.label || SORT_OPTIONS[0].label;
};

/**
 * Map filterKey to searchFilterKey. exmaple (multiColor -> seo_colors)
 * @param filterKey
 * @returns
 */
export const mapFilterKey = (filterKey: FilterKey): FilterKey => {
  if (filterKey === 'multiColor') return 'seo_colors';

  return filterKey;
};

/**
 * Format selected filter name. example (BLUE -> Blue, DARK_BLUE -> Dark blue)
 * @param {string} filterName
 * @returns {string}
 */
export const formatFilterName = (filterName: string): string =>
  capitalizeFirst(filterName, 1).replace(/_/, ' ');

/**
 * Default maximum filter's name to display
 */
const MAX_FILTER = 6;

export const getActivedFilterLabels = (
  searchFilters: SearchFilters,
  filterKey?: FilterKey
): string => {
  if (!filterKey) return '';

  const mappedFilterKey = mapFilterKey(filterKey);
  const filter = searchFilters[mappedFilterKey];

  if (Array.isArray(filter)) {
    const labels = filter?.map(formatFilterName).slice(0, MAX_FILTER) || [];

    if (filter?.length > MAX_FILTER) {
      labels.push(`+${filter.length - MAX_FILTER} more`);
    }

    return labels.join(', ');
  }

  return '';
};
